import { createAction } from 'redux-actions';

export const setUser = createAction('SET_USER');